import { getFeature, isFeature } from 'Cloud/Application/FeaturesEs6';

/** Отключение аналитики по тамбам */
export const disableThumbLogs = isFeature('disable-thumb-logs');

interface ThumbLogsParams {
    dwhEnabled: boolean;
    sendSuccess: boolean;
}

/** Параметры аналитики по тамбам */
export const thumbLogsParams: ThumbLogsParams = getFeature('thumb-logs-params') || {
    dwhEnabled: false,
    sendSuccess: false,
};
